(function () {
  var revealObserver;
  var mediaObserver;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initNavigation(root) {
    root.querySelectorAll('.lr9-nav').forEach(function (navigation) {
      if (navigation.dataset.lr9NavigationReady === 'true') return;
      navigation.dataset.lr9NavigationReady = 'true';
      navigation.classList.add('is-visible');
    });
  }

  function initReveals(root) {
    var selector = [
      '.lr9-heading',
      '.lr9-slider__header',
      '.lr9-story__media',
      '.lr9-media-carousel__frame',
      '.lr9-highlight',
      '.lr9-preorder__benefit',
      '.lr9-preorder__action > .lr9-button',
      '.lr9-preorder__trust',
      '.lr9-preorder__timeline',
      '.lr9-grid',
      '[data-lr9-carousel-track]',
      '.lr9-table-wrap',
      '[data-lr9-faqs]'
    ].join(',');
    var items = Array.prototype.slice.call(root.querySelectorAll(selector));

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }

    items.forEach(function (item, index) {
      if (item.dataset.lr9RevealReady === 'true') return;
      item.dataset.lr9RevealReady = 'true';
      item.classList.add('lr9-reveal');
      var delay = (index % 4) * 70;
      if (item.classList.contains('lr9-preorder__benefit')) {
        delay = Array.prototype.indexOf.call(item.parentElement.children, item) * 60 + 120;
      } else if (item.matches('.lr9-preorder__action > .lr9-button')) {
        delay = 300;
      } else if (item.classList.contains('lr9-preorder__trust')) {
        delay = 340;
      } else if (item.classList.contains('lr9-preorder__timeline')) {
        delay = 260;
      } else if (item.classList.contains('lr9-highlight')) {
        delay = Array.prototype.indexOf.call(item.parentElement.children, item) * 70;
      }
      item.style.setProperty('--lr9-reveal-delay', String(delay) + 'ms');
      revealObserver.observe(item);
    });
  }

  function initHeroMotion(root) {
    root.querySelectorAll('.lr9-hero').forEach(function (hero) {
      if (hero.dataset.lr9HeroReady === 'true') return;
      hero.dataset.lr9HeroReady = 'true';
      hero.classList.add('lr9-hero--motion');

      var items = hero.querySelectorAll('.lr9-eyebrow, .lr9-title, .lr9-copy, .lr9-hero__actions');
      items.forEach(function (item, index) {
        item.classList.add('lr9-hero__enter');
        item.style.setProperty('--lr9-hero-delay', String(index * 110 + 120) + 'ms');
      });

      if (prefersReducedMotion()) {
        hero.classList.add('is-ready');
        return;
      }

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { hero.classList.add('is-ready'); });
      });
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-lr9-tabs]').forEach(function (tabs) {
      if (tabs.dataset.lr9Ready === 'true') return;
      tabs.dataset.lr9Ready = 'true';

      var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[data-lr9-tab]'));
      var panels = Array.prototype.slice.call(tabs.querySelectorAll('[data-lr9-panel]'));
      var buttonRail = tabs.querySelector('.lr9-tabs__buttons');
      var indicator = tabs.querySelector('.lr9-tabs__indicator');

      var updateIndicator = function (button) {
        if (!buttonRail || !indicator || !button) return;
        indicator.style.width = String(button.offsetWidth) + 'px';
        indicator.style.transform = 'translateX(' + String(button.offsetLeft - 5) + 'px)';
      };

      var expandCapsule = function () {
        if (!buttonRail) return;
        var available = tabs.clientWidth;
        buttonRail.style.setProperty('--lr9-tabs-expanded-width', String(Math.min(buttonRail.scrollWidth, available)) + 'px');
        tabs.classList.add('is-expanded');
        window.requestAnimationFrame(function () { updateIndicator(buttons[0]); });
      };

      tabs.classList.add('lr9-tabs--capsule');
      if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
        expandCapsule();
      } else {
        var capsuleObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            expandCapsule();
            capsuleObserver.unobserve(tabs);
          });
        }, { threshold: 0.42 });
        capsuleObserver.observe(tabs);
      }

      buttons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          buttons.forEach(function (item, itemIndex) {
            item.setAttribute('aria-selected', itemIndex === index ? 'true' : 'false');
          });
          panels.forEach(function (panel, panelIndex) {
            var active = panelIndex === index;
            panel.hidden = !active;
            panel.classList.remove('lr9-tabs__panel--enter');
            if (active) {
              void panel.offsetWidth;
              panel.classList.add('lr9-tabs__panel--enter');
            }
          });
          updateIndicator(button);
        });
      });

      window.addEventListener('resize', function () {
        var active = buttons.find(function (button) { return button.getAttribute('aria-selected') === 'true'; });
        if (buttonRail) buttonRail.style.setProperty('--lr9-tabs-expanded-width', String(Math.min(buttonRail.scrollWidth, tabs.clientWidth)) + 'px');
        updateIndicator(active || buttons[0]);
      });
    });
  }

  function initFaqs(root) {
    root.querySelectorAll('[data-lr9-faq-button]').forEach(function (button) {
      if (button.dataset.lr9Ready === 'true') return;
      button.dataset.lr9Ready = 'true';

      button.addEventListener('click', function () {
        var answerId = button.getAttribute('aria-controls');
        var answer = document.getElementById(answerId);
        if (!answer) return;

        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        answer.hidden = expanded;
        var icon = button.querySelector('[data-lr9-faq-icon]');
        if (icon) icon.textContent = expanded ? '+' : '−';
      });
    });
  }

  function initGiftDialogs(root) {
    root.querySelectorAll('[data-lr9-gift-modal]').forEach(function (modal) {
      if (modal.dataset.lr9Ready === 'true') return;
      modal.dataset.lr9Ready = 'true';

      var closer = modal.querySelector('[data-lr9-gift-close]');
      modal.lr9Open = function (trigger) {
        modal.lr9LastTrigger = trigger || null;
        if (modal.open) return;
        if (typeof modal.showModal === 'function') modal.showModal();
        else modal.setAttribute('open', '');
      };

      modal.lr9Close = function () {
        if (!modal.open) return;
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
      };

      if (closer) closer.addEventListener('click', modal.lr9Close);
      modal.addEventListener('click', function (event) {
        if (event.target === modal) modal.lr9Close();
      });
      modal.addEventListener('close', function () {
        if (modal.lr9LastTrigger) modal.lr9LastTrigger.focus();
        modal.lr9LastTrigger = null;
      });
    });

    root.querySelectorAll('[data-lr9-gift-open]').forEach(function (button) {
      if (button.dataset.lr9GiftReady === 'true') return;
      button.dataset.lr9GiftReady = 'true';
      button.addEventListener('click', function () {
        var target = button.dataset.lr9GiftTarget;
        var modal = Array.prototype.find.call(document.querySelectorAll('[data-lr9-gift-modal]'), function (item) {
          return item.dataset.lr9GiftModal === target;
        });
        if (modal && modal.lr9Open) modal.lr9Open(button);
      });
    });

    if (document.documentElement.dataset.lr9GiftEditorReady !== 'true') {
      document.documentElement.dataset.lr9GiftEditorReady = 'true';
      document.addEventListener('shopify:section:select', function (event) {
        var modal = event.target.querySelector && event.target.querySelector('[data-lr9-gift-modal]');
        if (modal && modal.lr9Open) modal.lr9Open(null);
      });
      document.addEventListener('shopify:section:deselect', function (event) {
        var modal = event.target.querySelector && event.target.querySelector('[data-lr9-gift-modal]');
        if (modal && modal.lr9Close) modal.lr9Close();
      });
    }
  }

  function initAnchors(root) {
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      if (link.dataset.lr9Ready === 'true') return;
      link.dataset.lr9Ready = 'true';

      link.addEventListener('click', function (event) {
        var target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initCarousels(root) {
    root.querySelectorAll('[data-lr9-carousel]').forEach(function (carousel) {
      if (carousel.dataset.lr9Ready === 'true') return;
      carousel.dataset.lr9Ready = 'true';

      var section = carousel.closest('.lr9-section');
      var track = carousel.querySelector('[data-lr9-carousel-track]');
      if (!section || !track) return;

      var previous = section.querySelector('[data-lr9-carousel-prev]');
      var next = section.querySelector('[data-lr9-carousel-next]');
      var items = Array.prototype.slice.call(track.children);
      var framePending = false;
      var currentIndex = 0;
      track.classList.add('lr9-carousel-ready');

      var getActiveIndex = function () {
        if (!items.length) return 0;
        var center = track.scrollLeft + track.clientWidth / 2;
        var closest = items[0];
        var distance = Infinity;
        items.forEach(function (item) {
          var itemCenter = item.offsetLeft + item.offsetWidth / 2;
          var itemDistance = Math.abs(itemCenter - center);
          if (itemDistance < distance) {
            distance = itemDistance;
            closest = item;
          }
        });
        return items.indexOf(closest);
      };

      var setActive = function (activeIndex) {
        currentIndex = activeIndex;
        items.forEach(function (item, itemIndex) {
          item.classList.toggle('is-active', itemIndex === activeIndex);
          item.classList.toggle('is-before', itemIndex < activeIndex);
          item.classList.toggle('is-after', itemIndex > activeIndex);
        });
      };

      var updateActive = function () {
        framePending = false;
        if (!items.length) return;
        setActive(getActiveIndex());
      };

      // Plain, synchronous scrollLeft assignment: no scrollTo()/smooth
      // behavior, no requestAnimationFrame. Both of those can silently fail
      // to move the track at all (smooth scrolling fighting scroll-snap on
      // some browsers, rAF-driven tweens never progressing on some tabs) —
      // a direct assignment is the one thing that reliably works everywhere.
      // CSS `scroll-behavior: smooth` on the track (if present) still gives
      // this a native animated feel without any of that JS-side risk.
      var snapResumeTimer;
      var scrollToLeft = function (targetLeft) {
        track.classList.add('lr9-snap-suspended');
        window.clearTimeout(snapResumeTimer);
        track.scrollLeft = targetLeft;
        snapResumeTimer = window.setTimeout(function () {
          track.classList.remove('lr9-snap-suspended');
        }, 500);
      };

      var centeredLeft = function (item) {
        var target = item.offsetLeft - (track.clientWidth - item.offsetWidth) / 2;
        return Math.max(0, Math.min(track.scrollWidth - track.clientWidth, target));
      };

      var move = function (direction) {
        if (!items.length) return;
        var targetIndex = getActiveIndex() + direction;
        targetIndex = Math.max(0, Math.min(items.length - 1, targetIndex));
        scrollToLeft(centeredLeft(items[targetIndex]));
      };

      track.addEventListener('scroll', function () {
        if (framePending) return;
        framePending = true;
        window.requestAnimationFrame(updateActive);
      }, { passive: true });

      if (previous) previous.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });

      // Clicking a card selects it directly (it grows via the .is-active
      // CSS) instead of relying on scroll position, and stops autoplay so
      // the user's choice doesn't get overridden a moment later.
      var stopAutoplay = function () {};
      items.forEach(function (item, index) {
        item.addEventListener('click', function () {
          stopAutoplay();
          setActive(index);
          scrollToLeft(centeredLeft(item));
        });
      });

      window.requestAnimationFrame(updateActive);

      var autoplayDelay = parseInt(carousel.dataset.lr9Autoplay || '', 10);
      // Autoplay runs regardless of prefers-reduced-motion: the tick itself
      // is an instant position jump (no animation), so there is nothing to
      // reduce. Only the hand-tweened scrollToLeft() animation (used for
      // clicks/buttons) actually skips itself for reduced-motion users.
      if (autoplayDelay > 0) {
        var timer;
        var stop = function () {
          if (!timer) return;
          window.clearInterval(timer);
          timer = null;
        };
        stopAutoplay = stop;
        var start = function () {
          stop();
          timer = window.setInterval(function () {
            // Plain, synchronous scrollLeft assignment: no scrollTo()/smooth
            // behavior, no requestAnimationFrame. This is the one thing that
            // reliably moves the track regardless of scroll-snap quirks.
            if (!items.length) return;
            var nextIndex = (currentIndex + 1) % items.length;
            setActive(nextIndex);
            track.scrollLeft = centeredLeft(items[nextIndex]);
          }, autoplayDelay);
        };
        var canHover = !window.matchMedia || window.matchMedia('(hover: hover)').matches;
        if (canHover) {
          carousel.addEventListener('mouseenter', stop);
          carousel.addEventListener('mouseleave', start);
        }
        carousel.addEventListener('focusin', stop);
        carousel.addEventListener('focusout', start);
        carousel.addEventListener('touchstart', stop, { passive: true });
        carousel.addEventListener('touchend', start, { passive: true });
        start();
      }
    });
  }

  function initMediaStoryCarousels(root) {
    root.querySelectorAll('[data-lr9-media-carousel]').forEach(function (carousel) {
      if (carousel.dataset.lr9Ready === 'true') return;
      carousel.dataset.lr9Ready = 'true';

      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-lr9-media-slide]'));
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-lr9-media-dot]'));
      var previous = carousel.querySelector('[data-lr9-media-prev]');
      var next = carousel.querySelector('[data-lr9-media-next]');
      var currentLabel = carousel.querySelector('[data-lr9-media-current]');
      var videos = Array.prototype.slice.call(carousel.querySelectorAll('video'));
      var delay = parseInt(carousel.dataset.lr9MediaAutoplay || '0', 10);
      var activeIndex = 0;
      var timer;
      var startedAt = 0;
      var remaining = delay;
      var pauseReasons = {};
      var pointerStartX = 0;

      if (!slides.length) return;
      carousel.style.setProperty('--lr9-media-duration', String(delay || 6000) + 'ms');
      videos.forEach(function (video) {
        video.dataset.lr9CarouselVideo = 'true';
        video.pause();
      });

      var isPaused = function () {
        return Object.keys(pauseReasons).length > 0;
      };

      var syncVideo = function () {
        videos.forEach(function (video) { video.pause(); });
        if (pauseReasons.viewport || pauseReasons.visibility || prefersReducedMotion()) return;
        var activeVideo = slides[activeIndex].querySelector('video');
        if (!activeVideo) return;
        var playPromise = activeVideo.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      };

      var clearTimer = function () {
        if (!timer) return;
        window.clearTimeout(timer);
        timer = null;
      };

      var schedule = function () {
        clearTimer();
        if (delay <= 0 || slides.length < 2 || prefersReducedMotion() || isPaused()) return;
        startedAt = Date.now();
        timer = window.setTimeout(function () {
          activate(activeIndex + 1);
        }, Math.max(300, remaining));
      };

      var restartProgress = function () {
        remaining = delay;
        carousel.classList.remove('is-playing');
        void carousel.offsetWidth;
        if (delay > 0 && slides.length > 1 && !prefersReducedMotion()) carousel.classList.add('is-playing');
        carousel.classList.toggle('is-paused', isPaused());
        schedule();
      };

      var pause = function (reason) {
        if (pauseReasons[reason]) return;
        pauseReasons[reason] = true;
        if (timer) remaining = Math.max(300, remaining - (Date.now() - startedAt));
        clearTimer();
        carousel.classList.add('is-paused');
        if (reason === 'viewport' || reason === 'visibility') syncVideo();
      };

      var resume = function (reason) {
        delete pauseReasons[reason];
        if (isPaused()) return;
        carousel.classList.remove('is-paused');
        schedule();
        syncVideo();
      };

      var activate = function (nextIndex) {
        activeIndex = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, index) {
          var active = index === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (dot, index) {
          dot.setAttribute('aria-selected', index === activeIndex ? 'true' : 'false');
        });
        if (currentLabel) currentLabel.textContent = ('0' + String(activeIndex + 1)).slice(-2);
        syncVideo();
        restartProgress();
      };

      if (previous) previous.addEventListener('click', function () { activate(activeIndex - 1); });
      if (next) next.addEventListener('click', function () { activate(activeIndex + 1); });
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () { activate(index); });
      });

      carousel.addEventListener('mouseenter', function () { pause('hover'); });
      carousel.addEventListener('mouseleave', function () { resume('hover'); });
      carousel.addEventListener('focusin', function () { pause('focus'); });
      carousel.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!carousel.contains(document.activeElement)) resume('focus');
        }, 0);
      });
      carousel.addEventListener('pointerdown', function (event) {
        pointerStartX = event.clientX;
        pause('pointer');
      });
      carousel.addEventListener('pointerup', function (event) {
        var distance = event.clientX - pointerStartX;
        if (Math.abs(distance) > 48) activate(activeIndex + (distance < 0 ? 1 : -1));
        resume('pointer');
      });
      carousel.addEventListener('pointercancel', function () { resume('pointer'); });
      carousel.addEventListener('shopify:block:select', function (event) {
        var slide = event.target.closest('[data-lr9-media-slide]');
        if (!slide) return;
        activate(slides.indexOf(slide));
        pause('editor');
      });

      if ('IntersectionObserver' in window) {
        pause('viewport');
        var carouselObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) resume('viewport');
            else pause('viewport');
          });
        }, { threshold: 0.28 });
        carouselObserver.observe(carousel);
      }

      var updateVisibility = function () {
        if (document.hidden) pause('visibility');
        else resume('visibility');
      };
      document.addEventListener('visibilitychange', updateVisibility);
      updateVisibility();
      activate(0);
    });
  }

  function initStories(root) {
    root.querySelectorAll('[data-lr9-story-frame]').forEach(function (frame) {
      if (frame.dataset.lr9StoryReady === 'true') return;
      frame.dataset.lr9StoryReady = 'true';

      if (prefersReducedMotion()) {
        frame.style.setProperty('--lr9-story-scale', '1');
        return;
      }

      var framePending = false;
      var updateScrollMotion = function () {
        framePending = false;
        var rect = frame.getBoundingClientRect();
        var viewport = window.innerHeight || document.documentElement.clientHeight;
        if (rect.bottom < 0 || rect.top > viewport) return;
        var centerOffset = (rect.top + rect.height / 2 - viewport / 2) / viewport;
        var shift = Math.max(-26, Math.min(26, centerOffset * -34));
        frame.style.setProperty('--lr9-story-shift', shift.toFixed(2) + 'px');
      };

      var requestScrollMotion = function () {
        if (framePending) return;
        framePending = true;
        window.requestAnimationFrame(updateScrollMotion);
      };

      frame.addEventListener('pointermove', function (event) {
        if (!window.matchMedia('(hover: hover)').matches) return;
        var rect = frame.getBoundingClientRect();
        var x = ((event.clientX - rect.left) / rect.width - 0.5) * 10;
        var y = ((event.clientY - rect.top) / rect.height - 0.5) * 8;
        frame.style.setProperty('--lr9-story-x', x.toFixed(2) + 'px');
        frame.style.setProperty('--lr9-story-y', y.toFixed(2) + 'px');
      });

      frame.addEventListener('pointerleave', function () {
        frame.style.setProperty('--lr9-story-x', '0px');
        frame.style.setProperty('--lr9-story-y', '0px');
      });

      window.addEventListener('scroll', requestScrollMotion, { passive: true });
      window.addEventListener('resize', requestScrollMotion);
      requestScrollMotion();
    });
  }

  function initMediaPlayback(root) {
    var videos = Array.prototype.slice.call(root.querySelectorAll('.lr9 video')).filter(function (video) {
      return !video.closest('[data-lr9-media-carousel]');
    });
    if (!videos.length) return;

    if (prefersReducedMotion()) {
      videos.forEach(function (video) { video.pause(); });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        var playPromise = video.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      });
      return;
    }

    if (!mediaObserver) {
      mediaObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            var playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.24, rootMargin: '8% 0px 8% 0px' });
    }

    videos.forEach(function (video) {
      if (video.dataset.lr9MediaReady === 'true') return;
      video.dataset.lr9MediaReady = 'true';
      mediaObserver.observe(video);
    });
  }

  function init(root) {
    initHeroMotion(root);
    initNavigation(root);
    initTabs(root);
    initFaqs(root);
    initGiftDialogs(root);
    initAnchors(root);
    initCarousels(root);
    initMediaStoryCarousels(root);
    initStories(root);
    initMediaPlayback(root);
    initReveals(root);
  }

  function initPage() {
    document.documentElement.classList.add('lr9-motion-ready');
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPage);
  } else {
    initPage();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

